import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const DouyinGetMusicParamsSchema = ActionCommonParamsSchema.extend({
    keyword: z.string().optional(),
    count: z.number().optional(),
});

export type DouyinGetMusicParams = z.infer<typeof DouyinGetMusicParamsSchema>;
